export default __webpack_public_path__ + "static/media/savings.54a8b0e1.svg";